import React, { FormEvent, useState } from "react"

import Input from "../shared/input"
import ROUTES from "../services/routes"
import useHistoryCustom from "../hooks/useHistoryCustom"
import UserApi from "../services/api/User.api"
import MessageError from "../shared/message.error"

const CreateAccount = () => {
  const history = useHistoryCustom()

  const [firstName, setFirstname] = useState<string>("")
  const [lastName, setLastname] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [error, setError] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(false)

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setLoading(true)
    setError("")

    try {
      await new UserApi().create({ firstName, lastName, email, password })
      history.push(ROUTES.LOGIN)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="form">
      <form
        onSubmit={onSubmit}
        className="field"
        style={{
          width: "390px",
          maxWidth: "90vw"
        }}
      >
        <Input
          value={firstName}
          onChange={setFirstname}
          type="text"
          label="Prénom"
          minLength={2}
          required
          focus
        />
        <Input
          value={lastName}
          onChange={setLastname}
          type="text"
          label="Nom"
          minLength={2}
          required
        />
        <Input
          value={email}
          onChange={setEmail}
          type="email"
          label="Email"
          required
        />
        <Input
          value={password}
          onChange={setPassword}
          type="password"
          label="Mot de passe"
          required
        />
        {error === "Cet email est déjà utilisé sur ce domaine" ? (
          <article className="message is-danger field">
            <div className="message-body">
              <div>
                Cette adresse email est déjà utilisée par un autre utilisateur.
                <br />
                Si cette adresse email est la vôtre, nous vous invitons à vous
                connecter par l’étape :
              </div>
              <div className="has-text-centered">
                <button
                  className="button is-primary is-light is-outlined"
                  type="button"
                  onClick={() => history.push(ROUTES.PASSWORD_FORGOT)}
                  style={{ marginTop: "1.25em" }}
                >
                  J&apos;ai oublié mon mot de passe
                </button>
              </div>
            </div>
          </article>
        ) : (
          <MessageError message={error} />
        )}

        <button
          type="submit"
          style={{ width: "100%" }}
          className={`button is-primary field ${loading && "is-loading"}`}
        >
          Créer un compte
        </button>
      </form>

      <div className="is-divider" data-content="Vous avez déjà un compte ?" />
      <button
        type="button"
        style={{ width: "100%" }}
        className="button is-primary is-light field is-outlined"
        onClick={() => history.push(ROUTES.LOGIN)}
      >
        Me connecter
      </button>
    </div>
  )
}

export default CreateAccount
